/* unplugin-vue-components disabled */import { render } from "./widget.vue?vue&type=template&id=c15acc98&scoped=true"
import script from "./widget.vue?vue&type=script&lang=js"
export * from "./widget.vue?vue&type=script&lang=js"

import "./widget.vue?vue&type=style&index=0&id=c15acc98&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c15acc98"],['__file',"src/components/widgets/widget.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c15acc98"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c15acc98', __exports__)) {
    api.reload('c15acc98', __exports__)
  }
  
  module.hot.accept("./widget.vue?vue&type=template&id=c15acc98&scoped=true", () => {
    api.rerender('c15acc98', render)
  })

}


export default __exports__